module.exports = __webpack_public_path__ + "static/media/24-1.1a10e4de.mp3";